import React from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";

export default function CanvasFilter(props) {
  const {
    filterJadwal,
    setFilterJadwal,
    selectorSBU,
    fetchSelectorUnit,
    selectorUnit,
    loadingUnit,
    openCanvas,
    setOpenCanvas,
    fetchJadwalDokter,
    setLoadingLoad,
  } = props;

  return (
    <Offcanvas
      show={openCanvas}
      onHide={() => setOpenCanvas(false)}
      key="filter"
      placement="bottom"
      name="filter"
      style={{ zIndex: 99999, minHeight: "65%" }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Pilih Poli</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Rumah Sakit / Klinik Tujuan</Form.Label>
            <Select
              styles={{
                color: "black",
              }}
              id="sbu"
              name="sbu"
              options={selectorSBU}
              value={selectorSBU.find(
                (find) => find?.value === filterJadwal?.sbu
              )}
              onChange={(e) => {
                fetchSelectorUnit(e.value);
                setFilterJadwal({
                  ...filterJadwal,
                  sbu: e.value,
                  poli: null,
                });
              }}
            />
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Label>Unit Rawat Jalan Tujuan</Form.Label>
            {filterJadwal?.sbu !== null ? (
              <Select
                styles={{
                  color: "black",
                }}
                id="unit"
                name="unit"
                options={selectorUnit}
                isLoading={loadingUnit}
                value={selectorUnit.find(
                  (find) => find?.value === filterJadwal?.poli
                )}
                onChange={(e) => {
                  setFilterJadwal({
                    ...filterJadwal,
                    poli: e.value,
                    namapoli: e.name,
                  });
                }}
              />
            ) : (
              <Form.Control
                type="text"
                value="Pilih Rumah Sakit / Klinik Tujuan Terlebih Dahulu..."
                disabled
              />
            )}
          </Form.Group>
          <br />
          <div className="d-grid gap-2">
            <Button
              variant="warning"
              disabled={
                filterJadwal?.sbu === null || filterJadwal?.poli === null
              }
              onClick={() => {
                setOpenCanvas(false);
                setLoadingLoad(true);
                fetchJadwalDokter();
              }}
            >
              Simpan
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
